import { DocumentService } from 'src/app/core/service/document.service';
import { Member } from '../../member/model/member';
import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MemberService } from 'src/app/core/service/member.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { UserService } from 'src/app/core/service/user.service';
import { forkJoin } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-send-document',
  templateUrl: './send-document.component.html',
  styleUrls: ['./send-document.component.scss']
})
export class SendEmailComponent
{
  @Input() public memberId: number;
  @Input() public caseId: any;
  @Input() public documentUrl: string;
  @Input() public documentName: string;

  public dialogSendEmailOpened = false;
  public emailForm: any;
  public toAddresses: Array<string> = [];
  public sendingEmail = false;

  constructor(
    private fb: UntypedFormBuilder,
    private memberService: MemberService,
    private documentService: DocumentService,
    private messageHandlerService: MessageHandlerService,
    private userService: UserService
  ) { }

  public get to(): UntypedFormControl
  {
    return this.emailForm.get('to');
  }

  public get subject(): UntypedFormControl
  {
    return this.emailForm.get('subject');
  }

  public get body(): UntypedFormControl
  {
    return this.emailForm.get('body');
  }

  public execute(): void
  {
    if (this.memberId !== undefined && this.memberId !== null)
    {
      this.memberService.getMember(this.memberId).subscribe({
        next: (member) =>
        {
          this.buildForm(member);
        }
      });
    }
    else
    {
      this.buildForm();
    }
  }

  public cancel(): void
  {
    this.dialogSendEmailOpened = false;
  }

  public sendEmail(): void
  {
    this.sendingEmail = true;

    const formData = {
      to: this.to.value,
      subject: this.subject.value,
      body: this.body.value,
      documentUrl: this.documentUrl
    };

    this.documentService.sendDocument(formData).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('DOCUMENT-SENT');
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      },
      complete: () =>
      {
        this.dialogSendEmailOpened = false;
        this.sendingEmail = false;
      }
    });
  }

  private buildForm(member: Member = null): void
  {
    let toAddress = [];
    this.toAddresses = [];

    if (member)
    {
      toAddress = this.setToEmailAddresses(member);
    }

    this.emailForm = this.fb.group({
      to: [{ value: toAddress, disabled: false }, Validators.required],
      subject: [null, Validators.required],
      body: [null, Validators.required]
    });

    this.dialogSendEmailOpened = true;
  }

  /**
   * This method set the default email address for the patient.
   * It also add any none Channels provider email addresses of the care team members.
   *
   * @param member Current member object
   * @param caseId Current case id
   */
  private setToEmailAddresses(member: Member): any[]
  {
    const toAddress = [];

    // 1. Add patient email
    if (member.contact && member.contact.email)
    {
      this.toAddresses.push(member.contact.email);
      toAddress.push(member.contact.email);
    }

    // 2. Add care team emails if any
    const queries: any = [];
    queries.push(this.userService.getNonUsersByMember(this.memberId, null));

    // 3. Add care team emails of the case if any
    if (this.caseId && this.caseId !== undefined && this.caseId > 0)
    {
      queries.push(this.userService.getTeamNonUsersByCase(this.caseId));
    }

    // Run queries
    forkJoin(queries).subscribe({
      next: (responseList: []) =>
      {
        responseList.forEach((q: any) =>
        {
          q.forEach(d =>
          {
            // Add email if not already found
            if (d.email && this.toAddresses.indexOf(d.email) === -1)
            {
              this.toAddresses.push(d.email);
            }
          });
        });
      }
    });
    return toAddress;
  }

}
